import { 
	DETAILED_RECIPE,
	REQUESTING
} from '../constants';
import {checkForwardMatch} from '../logics/utility';

const initialState = {
	scores:[],
	fetchingStates:{
		recipe : REQUESTING.NONE,
		score : REQUESTING.NONE
	},
	recipe:null,
	error:null,
	errorMessage : null,
};

function handleRestAction(state, action) {
	
	const {fetchingState} = action.payload;

	const nextStates = {
		...state.fetchingStates,
		[action.type] : action.payload.fetchingState
	};
	if(fetchingState === REQUESTING.FETCHING){
		return {
			...state,
			fetchingStates : nextStates,
			error : null,
			errorMessage : null,
		};
	}
	if(fetchingState === REQUESTING.FAIL){
		const {error,message} = action.payload;
		return {
			...state,
			fetchingStates : nextStates,
			error,
			errorMessage : message
		};
	}

	switch (action.type) {
	case DETAILED_RECIPE.READ_SCORE:
	{
		return {
			...state,
			fetchingStates:nextStates,
			scores:action.payload.scores
		};
	}
	case DETAILED_RECIPE.READ_RECIPE:
	{
		return {
			...state,
			fetchingStates:nextStates,
			recipe : action.payload.recipe
		};
	}
	default:
		return state;
	}
}

export default function recipeDetailReducer(state = initialState, action) {
	
	if(!checkForwardMatch(action.type,DETAILED_RECIPE.PREFIX)){
		return state;
	}
	const {payload} = action;
	if(payload && payload.fetchingState){
		return handleRestAction(state, action);
	}
	return state;
}